import React from 'react'
import { IconX } from '@tabler/icons-react'
import { Draggable } from 'react-beautiful-dnd'
import { useSelector } from 'react-redux'

import { Button } from '@/components/buttons/Button'
import { Pill } from '@/components/pills/Pill'

export const Tag = ({ tag, index, deleteTag }) => {
  const edit_users = useSelector((state) => state.currentUser.edit_users)
  return (
    <Draggable draggableId={tag.id.toString()} index={index} isDragDisabled={!edit_users}>
      {(provided) => (
        <div
          className="tag-container"
          data-testid="tag-container"
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          <Pill
            xs
            emphasized
            clickable
            className="tag-pill"
            alignIcon="right"
            icon={
              edit_users ? (
                <Button
                  basic
                  circular
                  xs
                  icon={<IconX />}
                  data-testid="delete_tag_button"
                  aria-label={`Delete ${tag.content}`}
                  title={`Delete ${tag.content}`}
                  onClick={() => deleteTag(tag)}
                />
              ) : null
            }
          >
            {tag.content}
          </Pill>
        </div>
      )}
    </Draggable>
  )
}
